import React from 'react';
import { Image, Text, View } from 'react-native';
import { img_collapse } from '../../../../utils/ImagesManagementUtils';
import { Current_account_123, Dollar_35000 } from '../../../../utils/DictionaryManagementUtils';

const AccountBalance = ({
  globJSON, showExpendBox,
}) => {
  const { colors } = globJSON.configurations.theme;
  const myStyles = {
    container: {
      flexDirection: 'row',
      backgroundColor: colors.light_elements_color,
      boxShadow: '0 0 1px 0 rgba(0, 0, 0, 0.4)',
      justifyContent: 'center',
      padding: 6,
    },
    current_account_style: {
      textAlign: 'center',
    },
    currentAccountStyle: {
      marginTop: 5,
      fontSize: 8,
      lineHeight: 1.31,
      fontWeight: 500,
      color: colors.primary_font_color,
    },
    amountStyle: {
      marginTop: 5,
      height: 13,
      fontSize: 12,
      fontWeight: 700,
      color: colors.primary_font_color,
    },
    expendContainer: {
      position: 'absolute',
      end: 25,
      top: 11,
      width: 14,
      height: 14,
      backgroundColor: colors.primary_cta_color,
      borderRadius: globJSON.configurations.theme.radius.elements_shape_square ? 1.5 : 7,
    },
    expendIcon: {
      width: 10,
      height: 10,
      tintColor: colors.cta_font_color,
      margin: 'auto',
    },

  };
  return (
    <View style={myStyles.container}>
      <View style={myStyles.current_account_style}>
        <Text style={myStyles.currentAccountStyle}>{Current_account_123}</Text>
        <Text style={myStyles.amountStyle}>{Dollar_35000}</Text>
      </View>
      {showExpendBox && (
      <View style={myStyles.expendContainer}>
        <Image style={myStyles.expendIcon} source={img_collapse} />
      </View>
      )}
    </View>
  );
};
export default AccountBalance;
